export const ContactIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M18.0694 19H6.30017C4.86171 19 3.68478 17.8545 3.68478 16.4545V7.54545C3.68478 6.14545 4.86171 5 6.30017 5H18.0694C19.5079 5 20.6848 6.14545 20.6848 7.54545V16.4545C20.6848 17.8545 19.5079 19 18.0694 19Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.18478 8.99988L12 13L20.5 8.99988"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
